<footer class="d-print-none">
    <div class="logo" (click)="goHomePage()"></div>
    <div class="footer-container">
        <a [routerLink]="['/confidentiality', projectCode]" [queryParamsHandling]="'preserve'">{{
            'SHARED.FOOTER.CONFIDENTIALITY' | translate
        }}</a>
    </div>
</footer>
